import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { getUserRoles } from "../../utils/helpers";
import { entitledConsoles, landingPathFor } from "../../v2/constants/consoles";
import { savePreferredConsoleId } from "../../v2/constants/consolePreference";

// The one route registered for EVERY role.
//
// It exists because KAM, DOCTOR and PARTNER appear in zero of ROUTER_ROLES_MAP's
// entries, and legacy registers routes by omission -- so before this page there was
// literally no URL in the app those roles were permitted to load. They authenticated
// successfully and were then left sitting on /login with valid cookies, which reads as
// "login is broken" rather than "your account has no dashboard".
//
// Two audiences, so two states: someone who does have consoles (arriving here via a
// stale link) gets a way back in; someone who genuinely has none gets told so plainly,
// with the action that actually resolves it.
function Welcome() {
    const navigate = useNavigate();
    const roles = getUserRoles();
    const consoles = entitledConsoles(roles);

    let name = "";
    try {
        const raw = Cookies.get("user");
        if (raw) name = JSON.parse(raw).name || "";
    } catch (error) {
        name = "";
    }

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <div className="bg-white rounded-2xl shadow-soft-xl p-8 max-w-[640px]">
                <h1 className="text-2xl font-bold font-sans mb-2">
                    {name ? `Welcome, ${name}` : "Welcome"}
                </h1>

                {consoles.length > 0 ? (
                    <>
                        <p className="text-gray-600 font-sans mb-6">Pick where you want to work.</p>
                        <div className="flex flex-wrap gap-3">
                            {consoles.map((entry) => (
                                <button
                                    key={entry.id}
                                    type="button"
                                    onClick={() => {
                                        savePreferredConsoleId(entry.id);
                                        navigate(landingPathFor(entry.id, roles));
                                    }}
                                    className="bg-elm-500 text-white-50 px-4 py-3 rounded-2xl font-sans font-semibold"
                                >
                                    {entry.label}
                                </button>
                            ))}
                        </div>
                    </>
                ) : (
                    <p className="text-gray-600 font-sans">
                        This account doesn&apos;t have a dashboard assigned yet. Ask an administrator to grant
                        your user the role you need, then sign in again.
                    </p>
                )}
            </div>
        </div>
    );
}

export default Welcome;
